import { cn } from '../../../utils';
import { Skeleton } from '../Common/Skeleton';

const PostCardSkeleton = ({ noImage = false, className }) => {
  return (
    <div className={cn('flex w-full md:max-w-[320px] flex-col border-[1px] border-light-grey bg-white', className)}>
      {!noImage && <Skeleton className='h-[171px] w-full' />}
      <div className='flex items-center gap-2 p-4'>
        <Skeleton className='h-8 w-8 rounded-full' />
        <div className=''>
          <Skeleton className='mb-[10px] h-[12px] w-[75px]' />
          <div className='flex items-center gap-[10px]'>
            <Skeleton className='h-[13px] w-[62px]' />
            <Skeleton className='h-[13px] w-[75px]' />
          </div>
        </div>
      </div>
      <div className='flex w-full flex-1 flex-col gap-2 border-y-[1px] border-light-grey p-4'>
        {noImage ? (
          <>
            <Skeleton className='h-[40px] w-full' />
            <Skeleton className='h-[40px] w-[200px]' />
            <Skeleton className='h-[20px] w-full' />
            <Skeleton className='h-[20px] w-full' />
            <Skeleton className='h-[20px] w-full' />
            <Skeleton className='h-[20px] w-full' />
            <Skeleton className='h-[20px] w-full' />
          </>
        ) : (
          <Skeleton className='h-[50px] w-full' />
        )}

        <Skeleton className='h-[20px] w-full' />
        <Skeleton className='h-[20px] w-[167px]' />
      </div>
      <div className='flex justify-between p-4'>
        <Skeleton className='h-[22px] w-[80px]' />
        <Skeleton className='h-[22px] w-[80px]' />
      </div>
    </div>
  );
};

export default PostCardSkeleton;
